var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wine-product-page" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _vm.item
                ? _c(
                    "b-col",
                    [
                      _vm.item
                        ? _c("node-element-local-tasks", {
                            attrs: { itemid: _vm.itemid },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.notPublished
                        ? _c("div", { staticClass: "messages warning" }, [
                            _vm._v("\n          Not published\n        "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.item
        ? [
            _c(_vm.productDetailPageComponent, {
              tag: "component",
              attrs: { item: _vm.item },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("page-content-creator", {
        attrs: { itemid: _vm.itemid, pos: "bottom" },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }